var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _text, _path9, _path10, _path11, _div, _text2, _path12, _div2, _text3, _path13, _path14, _path15, _br, _div3, _text4, _path16, _path17, _div4, _br2, _text5, _path18, _br3, _div5, _text6, _path19, _div6, _text7, _path20, _text8, _path21, _text9, _path22, _br4, _div7, _div8, _text10, _path23, _div9, _div10, _text11, _rect4, _h, _p, _text12, _path24, _div11, _text13, _path25, _path26, _path27, _rect5, _h2, _p2, _text14, _rect6, _rect7, _path28, _path29, _path30, _div12, _text15, _path31, _div13, _text16, _path32, _path33, _path34, _br5, _div14, _text17, _path35, _path36, _div15, _br6, _text18, _path37, _div16, _text19, _path38, _br7, _div17, _div18, _text20, _path39, _div19, _text21, _path40, _path41, _path42, _path43, _path44, _rect8, _h3, _p3, _p4, _text22, _rect9, _rect10, _text23, _path45, _path46, _path47, _rect11, _div20, _div21, _text24, _rect12, _div22, _div23, _text25, _path48, _path49, _path50, _rect13, _div24, _div25, _text26, _path51, _div26, _div27, _text27, _path52, _rect14, _h4, _p5, _text28, _rect15, _h5, _p6, _text29, _rect16, _h6, _p7, _text30, _path53, _div28, _div29, _div30, _text31, _path54, _div31, _div32, _text32, _rect17, _rect18, _text33, _path55, _path56, _path57, _rect19, _div33, _div34, _text34, _rect20, _div35, _div36, _text35, _path58, _path59, _path60, _rect21, _div37, _div38, _text36, _path61, _div39, _div40, _text37, _path62, _div41, _div42, _div43, _text38, _path63, _div44, _div45, _text39, _rect22, _div46, _div47, _div48, _text40, _rect23, _div49, _div50, _div51, _text41, _rect24, _div52, _div53, _div54, _text42, _rect25, _div55, _div56, _div57, _text43, _rect26, _div58, _div59, _div60, _text44, _path64, _rect27, _h7, _p8, _p9, _p10, _text45, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStructure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "872px",
    height: "1183px",
    viewBox: "-0.5 -0.5 872 1183",
    content: "<mxfile host=\"embed.diagrams.net\" modified=\"2021-12-16T16:33:33.686Z\" agent=\"5.0 (Windows)\" version=\"15.5.2\" etag=\"8-f-7SwRRg2fKspTDzkj\" type=\"embed\"><diagram id=\"m4geRX2Jg0PixQ0yUBIW\" name=\"Seite-1\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 330,
    width: 240,
    height: 440,
    fill: "none",
    stroke: "#3333ff",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50,
    width: 640,
    height: 160,
    fill: "none",
    stroke: "#ff0000",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 490,
    width: 120,
    height: 100,
    fill: "none",
    stroke: "#000000",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 260 110 L 60 110 L 60 163.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 168.88 L 56.5 161.88 L 60 163.63 L 63.5 161.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 260 110 L 195 110 L 195 183.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 195 188.88 L 191.5 181.88 L 195 183.63 L 198.5 181.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 380 110 L 460 110 L 460 183.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 460 188.88 L 456.5 181.88 L 460 183.63 L 463.5 181.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 380 110 L 575 110 L 575 183.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 575 188.88 L 571.5 181.88 L 575 183.63 L 578.5 181.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 110,
    rx: 60.00000000000001,
    ry: 40,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 118,
      height: 1,
      paddingTop: 110,
      marginLeft: 261
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Core\xA0 Kernel")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 114,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Core\xA0 Kernel")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 180 470 L 120 470 L 120 483.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 488.88 L 116.5 481.88 L 120 483.63 L 123.5 481.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 180 390 L 220 430 L 180 470 L 140 430 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 430,
      marginLeft: 141
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _div || (_div = /*#__PURE__*/React.createElement("div", null, "Database")))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 434,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 610 L 160 650 L 120 690 L 80 650 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 650,
      marginLeft: 81
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _div2 || (_div2 = /*#__PURE__*/React.createElement("div", null, "Client")))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 654,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 470 L 120 470 L 120 483.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 488.88 L 116.5 481.88 L 120 483.63 L 123.5 481.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 390 L 100 430 L 60 470 L 20 430 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 430,
      marginLeft: 21
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _br || (_br = /*#__PURE__*/React.createElement("br", null)), _div3 || (_div3 = /*#__PURE__*/React.createElement("div", null, "Cache")))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 434,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 90 515 C 90 506.72 103.43 500 120 500 C 127.96 500 135.59 501.58 141.21 504.39 C 146.84 507.21 150 511.02 150 515 L 150 565 C 150 573.28 136.57 580 120 580 C 103.43 580 90 573.28 90 565 Z",
    fill: "#fff2cc",
    stroke: "#d6b656",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 515 C 150 523.28 136.57 530 120 530 C 103.43 530 90 523.28 90 515",
    fill: "none",
    stroke: "#d6b656",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 553,
      marginLeft: 91
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div4 || (_div4 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;entity&gt;&gt;&gt;")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, "ORM-MODEL", _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null))))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 556,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "&lt;&lt;entity&gt;&gt;&gt;...")))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 170 L 100 210 L 60 250 L 20 210 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 210,
      marginLeft: 21
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null)), _div5 || (_div5 = /*#__PURE__*/React.createElement("div", null, "Logger")))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 214,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 730 L 160 770 L 120 810 L 80 770 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 770,
      marginLeft: 81
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _div6 || (_div6 = /*#__PURE__*/React.createElement("div", null, "Presenter")))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 774,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 170 190 L 220 190 L 240 210 L 220 230 L 170 230 L 150 210 Z",
    fill: "#ffe6cc",
    stroke: "#d79b00",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 210,
      marginLeft: 151
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Config Store")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 214,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Config Store")))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 435 190 L 485 190 L 505 210 L 485 230 L 435 230 L 415 210 Z",
    fill: "#ffe6cc",
    stroke: "#d79b00",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 210,
      marginLeft: 416
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Core Crypto-graphy")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 214,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Core Crypto-gra...")))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 290 L 160 330 L 120 370 L 80 330 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 330,
      marginLeft: 81
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null)), _div7 || (_div7 = /*#__PURE__*/React.createElement("div", null, "Log")), _div8 || (_div8 = /*#__PURE__*/React.createElement("div", null, "Chanel")))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 334,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 550 190 L 600 190 L 620 210 L 600 230 L 550 230 L 530 210 Z",
    fill: "#d5e8d4",
    stroke: "#82b366",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 210,
      marginLeft: 531
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div9 || (_div9 = /*#__PURE__*/React.createElement("div", null, "Core ", /*#__PURE__*/React.createElement("br", null))), _div10 || (_div10 = /*#__PURE__*/React.createElement("div", null, "Module", /*#__PURE__*/React.createElement("br", null))))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 575,
    y: 214,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Core...")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 50,
    width: 190,
    height: 120,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 182,
      height: 1,
      paddingTop: 40,
      marginLeft: 655
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 130,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _h || (_h = /*#__PURE__*/React.createElement("h1", null, "Kernel")), _p || (_p = /*#__PURE__*/React.createElement("p", null, "The kernel manages and provides a wide range of resources for the registered modules.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))))))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 655,
    y: 52,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Kernel...")))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 240 530 L 280 570 L 240 610 L 200 570 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 570,
      marginLeft: 201
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _div11 || (_div11 = /*#__PURE__*/React.createElement("div", null, "Bridge")))))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 574,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 723.63 L 120 696.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 728.88 L 116.5 721.88 L 120 723.63 L 123.5 721.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 691.12 L 123.5 698.12 L 120 696.37 L 116.5 698.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 650,
    y: 330,
    width: 190,
    height: 120,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 182,
      height: 1,
      paddingTop: 320,
      marginLeft: 655
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 130,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _h2 || (_h2 = /*#__PURE__*/React.createElement("h1", null, "Module")), _p2 || (_p2 = /*#__PURE__*/React.createElement("p", null, "Modules are purpose-specific collections of functions and business rules in an encapsulated environment.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))))))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 655,
    y: 332,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Module...")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 330,
    width: 240,
    height: 440,
    fill: "none",
    stroke: "#3333ff",
    pointerEvents: "all"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 490,
    width: 120,
    height: 100,
    fill: "none",
    stroke: "#000000",
    pointerEvents: "all"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 580 470 L 520 470 L 520 483.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 488.88 L 516.5 481.88 L 520 483.63 L 523.5 481.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 580 390 L 620 430 L 580 470 L 540 430 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 430,
      marginLeft: 541
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _div12 || (_div12 = /*#__PURE__*/React.createElement("div", null, "Database")))))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 434,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 610 L 560 650 L 520 690 L 480 650 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 650,
      marginLeft: 481
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _div13 || (_div13 = /*#__PURE__*/React.createElement("div", null, "Client")))))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 654,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 460 470 L 520 470 L 520 483.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 488.88 L 516.5 481.88 L 520 483.63 L 523.5 481.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 460 390 L 500 430 L 460 470 L 420 430 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 430,
      marginLeft: 421
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null)), _div14 || (_div14 = /*#__PURE__*/React.createElement("div", null, "Cache")))))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 434,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 490 515 C 490 506.72 503.43 500 520 500 C 527.96 500 535.59 501.58 541.21 504.39 C 546.84 507.21 550 511.02 550 515 L 550 565 C 550 573.28 536.57 580 520 580 C 503.43 580 490 573.28 490 565 Z",
    fill: "#fff2cc",
    stroke: "#d6b656",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 550 515 C 550 523.28 536.57 530 520 530 C 503.43 530 490 523.28 490 515",
    fill: "none",
    stroke: "#d6b656",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 553,
      marginLeft: 491
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 9,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div15 || (_div15 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;entity&gt;&gt;&gt;")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, "ORM-MODEL", _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null))))))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 556,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "9px",
    textAnchor: "middle"
  }, "&lt;&lt;entity&gt;&gt;&gt;...")))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 730 L 560 770 L 520 810 L 480 770 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 770,
      marginLeft: 481
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _div16 || (_div16 = /*#__PURE__*/React.createElement("div", null, "Presenter")))))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 774,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 290 L 560 330 L 520 370 L 480 330 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 330,
      marginLeft: 481
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _br7 || (_br7 = /*#__PURE__*/React.createElement("br", null)), _div17 || (_div17 = /*#__PURE__*/React.createElement("div", null, "Log")), _div18 || (_div18 = /*#__PURE__*/React.createElement("div", null, "Chanel")))))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 334,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 400 530 L 440 570 L 400 610 L 360 570 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 570,
      marginLeft: 361
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;interface&gt;&gt;"), _div19 || (_div19 = /*#__PURE__*/React.createElement("div", null, "Bridge")))))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 574,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;interface&gt;&gt;...")))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 723.63 L 520 696.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 728.88 L 516.5 721.88 L 520 723.63 L 523.5 721.88 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 520 691.12 L 523.5 698.12 L 520 696.37 L 516.5 698.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 280 570 L 353.63 570",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeDasharray: "3 3",
    pointerEvents: "stroke"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 358.88 570 L 351.88 573.5 L 353.63 570 L 351.88 566.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 580,
    width: 120,
    height: 220,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 112,
      height: 1,
      paddingTop: 570,
      marginLeft: 265
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 230,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _h3 || (_h3 = /*#__PURE__*/React.createElement("h1", null, "Bridges")), _p3 || (_p3 = /*#__PURE__*/React.createElement("p", null, "Bridges connect two modules unidirectional. ", /*#__PURE__*/React.createElement("br", null))), _p4 || (_p4 = /*#__PURE__*/React.createElement("p", null, "The Kernel resolve the\xA0 module bridge rquirements and check for\xA0 circular module load.", /*#__PURE__*/React.createElement("br", null))))))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 265,
    y: 582,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Bridges...")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 950,
    width: 310,
    height: 190,
    fill: "none",
    stroke: "#6c8ebf",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 920,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "#6c8ebf",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 935,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Express Kernel")))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 939,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Express Ke...")))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.92 996.37 L 109.75 1008.95",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.99 991.12 L 113.39 998.16 L 109.92 996.37 L 106.39 998.07 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.68 1014.2 L 106.28 1007.16 L 109.75 1008.95 L 113.28 1007.25 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 1015,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 1035,
      marginLeft: 51
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div20 || (_div20 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;action&gt;&gt;", /*#__PURE__*/React.createElement("br", null))), _div21 || (_div21 = /*#__PURE__*/React.createElement("div", null, "ExpressApiCall")))))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 1039,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;action&gt;&gt;...")))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 1025,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 1045,
      marginLeft: 61
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div22 || (_div22 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;action&gt;&gt;", /*#__PURE__*/React.createElement("br", null))), _div23 || (_div23 = /*#__PURE__*/React.createElement("div", null, "ExpressApiCall")))))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 1049,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;action&gt;&gt;...")))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.9 1081.09 L 109.97 1093.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.88 1075.84 L 113.41 1082.82 L 109.9 1081.09 L 106.41 1082.86 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.99 1098.88 L 106.46 1091.9 L 109.97 1093.63 L 113.46 1091.86 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 1035,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 1055,
      marginLeft: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div24 || (_div24 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;action&gt;&gt;", /*#__PURE__*/React.createElement("br", null))), _div25 || (_div25 = /*#__PURE__*/React.createElement("div", null, "ExpressApiCall")))))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 1059,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;action&gt;&gt;...")))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 110 1100 L 150 1140 L 110 1180 L 70 1140 Z",
    fill: "#bac8d3",
    stroke: "#23445d",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 1140,
      marginLeft: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;Endpoint&gt;&gt;"), _div26 || (_div26 = /*#__PURE__*/React.createElement("div", null, "Express-")), _div27 || (_div27 = /*#__PURE__*/React.createElement("div", null, "Server", /*#__PURE__*/React.createElement("br", null))))))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 1144,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;Endpoint&gt;&gt;...")))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 888 L 640 888 M 640 892 L 0 892 M 640 892",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 190,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 182,
      height: 1,
      paddingTop: 0,
      marginLeft: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 50,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _h4 || (_h4 = /*#__PURE__*/React.createElement("h1", null, "Core-Package", /*#__PURE__*/React.createElement("br", null))), _p5 || (_p5 = /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("br", null))))))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 12,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Core-Package...")))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 850,
    width: 240,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 232,
      height: 1,
      paddingTop: 840,
      marginLeft: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 50,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _h5 || (_h5 = /*#__PURE__*/React.createElement("h1", null, "Express-Package", /*#__PURE__*/React.createElement("br", null))), _p6 || (_p6 = /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("br", null))))))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 852,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Express-Package...")))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 850,
    width: 240,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 232,
      height: 1,
      paddingTop: 840,
      marginLeft: 405
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 50,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _h6 || (_h6 = /*#__PURE__*/React.createElement("h1", null, "Electron-Package", /*#__PURE__*/React.createElement("br", null))), _p7 || (_p7 = /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("br", null))))))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 852,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Electron-Package...")))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 220 960 L 270 960 L 290 987.5 L 270 1015 L 220 1015 L 200 987.5 Z",
    fill: "#d5e8d4",
    stroke: "#82b366",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 988,
      marginLeft: 201
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div28 || (_div28 = /*#__PURE__*/React.createElement("div", null, "Express")), _div29 || (_div29 = /*#__PURE__*/React.createElement("div", null, "Base", /*#__PURE__*/React.createElement("br", null))), _div30 || (_div30 = /*#__PURE__*/React.createElement("div", null, "Module", /*#__PURE__*/React.createElement("br", null))))))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 991,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Express...")))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 110 910 L 150 950 L 110 990 L 70 950 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 950,
      marginLeft: 71
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;"), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "presenter&gt;&gt;"), _div31 || (_div31 = /*#__PURE__*/React.createElement("div", null, "Express")), _div32 || (_div32 = /*#__PURE__*/React.createElement("div", null, "Action", /*#__PURE__*/React.createElement("br", null))))))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 954,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;presenter&gt;&gt;...")))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 950,
    width: 330,
    height: 190,
    fill: "none",
    stroke: "#6c8ebf",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 920,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "#6c8ebf",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 935,
      marginLeft: 331
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Electron Kernel")))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 939,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Electron K...")))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.92 996.37 L 439.75 1008.95",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.99 991.12 L 443.39 998.16 L 439.92 996.37 L 436.39 998.07 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.68 1014.2 L 436.28 1007.16 L 439.75 1008.95 L 443.28 1007.25 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 1015,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 1035,
      marginLeft: 381
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div33 || (_div33 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;action&gt;&gt;", /*#__PURE__*/React.createElement("br", null))), _div34 || (_div34 = /*#__PURE__*/React.createElement("div", null, "ExpressApiCall")))))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 425,
    y: 1039,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;action&gt;&gt;...")))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 1025,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 1045,
      marginLeft: 391
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div35 || (_div35 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;action&gt;&gt;", /*#__PURE__*/React.createElement("br", null))), _div36 || (_div36 = /*#__PURE__*/React.createElement("div", null, "ExpressApiCall")))))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 435,
    y: 1049,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;action&gt;&gt;...")))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.9 1081.09 L 439.97 1093.63",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.88 1075.84 L 443.41 1082.82 L 439.9 1081.09 L 436.41 1082.86 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.99 1098.88 L 436.46 1091.9 L 439.97 1093.63 L 443.46 1091.86 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 1035,
    width: 90,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 1055,
      marginLeft: 401
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div37 || (_div37 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;action&gt;&gt;", /*#__PURE__*/React.createElement("br", null))), _div38 || (_div38 = /*#__PURE__*/React.createElement("div", null, "ElectronIPCCall")))))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 445,
    y: 1059,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;action&gt;&gt;...")))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 440 1100 L 480 1140 L 440 1180 L 400 1140 Z",
    fill: "#bac8d3",
    stroke: "#23445d",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 1140,
      marginLeft: 401
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;Endpoint&gt;&gt;"), _div39 || (_div39 = /*#__PURE__*/React.createElement("div", null, "Electron-")), _div40 || (_div40 = /*#__PURE__*/React.createElement("div", null, "IPC", /*#__PURE__*/React.createElement("br", null))))))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 1144,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;Endpoint&gt;&gt;...")))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 571.5 960 L 621.5 960 L 641.5 987.5 L 621.5 1015 L 571.5 1015 L 551.5 987.5 Z",
    fill: "#d5e8d4",
    stroke: "#82b366",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 988,
      marginLeft: 553
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div41 || (_div41 = /*#__PURE__*/React.createElement("div", null, "Electron")), _div42 || (_div42 = /*#__PURE__*/React.createElement("div", null, "Base", /*#__PURE__*/React.createElement("br", null))), _div43 || (_div43 = /*#__PURE__*/React.createElement("div", null, "Module", /*#__PURE__*/React.createElement("br", null))))))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 597,
    y: 991,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Electron...")))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 440 910 L 480 950 L 440 990 L 400 950 Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 950,
      marginLeft: 401
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "&lt;&lt;p"), /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 9
    }
  }, "resenter&gt;&gt;"), _div44 || (_div44 = /*#__PURE__*/React.createElement("div", null, "Electron")), _div45 || (_div45 = /*#__PURE__*/React.createElement("div", null, "Action", /*#__PURE__*/React.createElement("br", null))))))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 954,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;presenter&gt;&gt;...")))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 1020,
    width: 65,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 63,
      height: 1,
      paddingTop: 1045,
      marginLeft: 241
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div46 || (_div46 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;DB&gt;&gt;")), _div47 || (_div47 = /*#__PURE__*/React.createElement("div", null, "SQLight")), _div48 || (_div48 = /*#__PURE__*/React.createElement("div", null, "Bundle", /*#__PURE__*/React.createElement("br", null))))))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 273,
    y: 1049,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;DB&gt;&gt;...")))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 1075,
    width: 65,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 63,
      height: 1,
      paddingTop: 1100,
      marginLeft: 241
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div49 || (_div49 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;DB&gt;&gt;")), _div50 || (_div50 = /*#__PURE__*/React.createElement("div", null, "PosgressDb")), _div51 || (_div51 = /*#__PURE__*/React.createElement("div", null, "Bundle", /*#__PURE__*/React.createElement("br", null))))))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 273,
    y: 1104,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;DB&gt;&gt;...")))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 1020,
    width: 65,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 63,
      height: 1,
      paddingTop: 1045,
      marginLeft: 169
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div52 || (_div52 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;logger&gt;&gt;")), _div53 || (_div53 = /*#__PURE__*/React.createElement("div", null, "E-Logger")), _div54 || (_div54 = /*#__PURE__*/React.createElement("div", null, "Bundle", /*#__PURE__*/React.createElement("br", null))))))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 201,
    y: 1049,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;logger&gt;&gt;...")))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 511.5,
    y: 1020,
    width: 65,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 63,
      height: 1,
      paddingTop: 1045,
      marginLeft: 513
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div55 || (_div55 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;logger&gt;&gt;")), _div56 || (_div56 = /*#__PURE__*/React.createElement("div", null, "E-Logger")), _div57 || (_div57 = /*#__PURE__*/React.createElement("div", null, "Bundle", /*#__PURE__*/React.createElement("br", null))))))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 544,
    y: 1049,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;logger&gt;&gt;...")))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 583.5,
    y: 1020,
    width: 65,
    height: 50,
    rx: 7.5,
    ry: 7.5,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 63,
      height: 1,
      paddingTop: 1045,
      marginLeft: 585
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _div58 || (_div58 = /*#__PURE__*/React.createElement("div", null, "&lt;&lt;DB&gt;&gt;")), _div59 || (_div59 = /*#__PURE__*/React.createElement("div", null, "SQLight")), _div60 || (_div60 = /*#__PURE__*/React.createElement("div", null, "Bundle", /*#__PURE__*/React.createElement("br", null))))))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 616,
    y: 1049,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "&lt;&lt;DB&gt;&gt;...")))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 318 1182 L 318 892 M 322 892 L 322 1182 M 322 892",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 950,
    width: 190,
    height: 200,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe flex-start",
      width: 182,
      height: 1,
      paddingTop: 940,
      marginLeft: 685
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left",
      maxHeight: 210,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _h7 || (_h7 = /*#__PURE__*/React.createElement("h1", null, "Actions")), _p8 || (_p8 = /*#__PURE__*/React.createElement("p", null, "- handle external user requests by an APICall or an IPCEmmit. ", /*#__PURE__*/React.createElement("br", null))), _p9 || (_p9 = /*#__PURE__*/React.createElement("p", null, "- used to impelemt business rules")), _p10 || (_p10 = /*#__PURE__*/React.createElement("p", null, "- registerd to\xA0 a specific presenter like Express or Electron", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))))))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 685,
    y: 952,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Actions...")))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 270 L 590 270",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 290 L 120 276.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 120 271.12 L 123.5 278.12 L 120 276.37 L 116.5 278.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 519.58 290 L 519.58 276.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 519.58 271.12 L 523.08 278.12 L 519.58 276.37 L 516.08 278.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 270 L 60 256.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 251.12 L 63.5 258.12 L 60 256.37 L 56.5 258.12 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M 194.66 270 L 194.95 236.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M 194.99 231.12 L 198.43 238.15 L 194.95 236.37 L 191.43 238.09 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M 460 270 L 459.71 236.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M 459.67 231.12 L 463.23 238.09 L 459.71 236.37 L 456.23 238.15 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M 574.92 270 L 574.63 236.37",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M 574.59 231.12 L 578.15 238.09 L 574.63 236.37 L 571.15 238.15 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructure);
export default __webpack_public_path__ + "static/media/structure.77b7e0120049c4260fd2365e882b26c5.svg";
export { ForwardRef as ReactComponent };